import React, { useEffect, useState } from 'react';
import Header from '../../components/IT-tracking/Header';
import { Button, Carousel, Image, Radio, Modal, Form, Input, Rate, DatePicker } from 'antd';
import './index.css';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getAllProducts, getDevice } from './utils';
import { getApi, putApi } from '../../services/api';
import { useDispatch } from 'react-redux';
import { showSnack } from 'react-redux-snackbar';

const dateFormat = 'DD/MM/YYYY';

const error = () => {
	Modal.error({
		title: 'Request Failed',
		afterClose: () => {},
		footer: null,
		onOk: () => {},
		content:
			'It looks like you have already filled the form or its expired right now. please connect with the respective HR team to generate new link.',
	});
};

const ShowAdditionalFeatures = function ({ additionFeatures }) {
	const featuresList = additionFeatures.split(',');
	return (
		<ul>
			{featuresList.map((el) => (
				<li>{el}</li>
			))}
		</ul>
	);
};

const EachInventoryProduct = () => {
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [selectedVariant, setSelectedVariant] = useState(null);
	const [points, setPoints] = useState([]);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [showDeliveryAddressModel, setDeliveryAddress] = useState(false);
	const [isModalOpen, setModalOpen] = useState(false);

	const [searchParams, setSearchParams] = useSearchParams();
	const token = searchParams.get('token');
	const navigate = useNavigate();

	useEffect(() => {
		const getOnboarding = async function () {
			const resp = await getApi(`/assetze/open-api/onboarding?token=${token}`);
			if (resp.type === 'error') {
				error();
			}
		};
		getOnboarding();
	}, [token]);

	let { id: deviceSelecte } = useParams();
	useEffect(() => {
		console.log(
			deviceSelecte,
			'deviceSelecte',
			getAllProducts(),
			getAllProducts().find((el) => {
				console.log(el.id, 'deviceS', deviceSelecte);
				return el.id === deviceSelecte * 1;
			})
		);

		const selectedProduct = getAllProducts().find((el) => el.id === deviceSelecte * 1);
		if (selectedProduct) {
			setSelectedProduct(selectedProduct);
			setPoints(selectedProduct.resourcePoints);
			setSelectedVariant(selectedProduct.allVariants[0]);
		} else {
			navigate('/device-not-found');
		}
	}, [deviceSelecte]);

	useEffect(() => {
		if (selectedProduct) {
			const selectedResourcePoint = points.reduce((acc, el) => {
				acc[el.key] = el.options[el.selectedPoint].value;
				return acc;
			}, {});
			console.log(selectedResourcePoint, 'selectedResourcePoint');

			for (let x = 0; x < selectedProduct.allVariants.length; x += 1) {
				const eachVariant = selectedProduct.allVariants[x];

				let counter = 0;
				const allKeys = Object.keys(selectedResourcePoint);
				for (let x = 0; x < Object.keys(selectedResourcePoint).length; x += 1) {
					if (eachVariant[allKeys[x]] === selectedResourcePoint[allKeys[x]]) {
						counter += 1;
					}
				}

				if (counter === allKeys.length) {
					console.log('selectedVariant', eachVariant);
					setSelectedVariant(eachVariant);
					return;
				}
			}
		}
	}, [points]);

	const resourceKeys = ['RAM', 'HDD'];

	const onOptionChange = (type, val) => {
		const newPoint = points.map((el) => {
			console.log(el.key, type);

			if (el.key == type) {
				for (let i = 0; i < el.options.length; i++) {
					if (el.options[i].value == val) {
						return { ...el, selectedPoint: i };
					}
				}
			}
			return el;
		});

		setPoints(newPoint);
	};

	console.log(selectedProduct, 'selectedProduct', points);

	if (!selectedProduct) {
		return null;
	}

	const productDeatils = {
		productName: selectedProduct.name || '',
		productType: selectedProduct.type || '',
		details: selectedProduct.details || '',
		features: selectedProduct.features || '',
		additionFeatures: selectedProduct.additionFeatures || '',
		mrp: selectedProduct.originalPrice * 1,
		price: selectedProduct.price * 1,
		images: selectedProduct.images,
	};

	const images = productDeatils.images;

	const { price, originalPrice } = selectedVariant;
	console.log(selectedVariant, 'selectedVariant');

	const handleOk = () => {
		console.log('handleOk');
	};

	const handleCancel = () => {
		console.log('handleCancel');
		setModalOpen(false);
	};

	return (
		<>
			<Header />

			<ProvideDeliveryDetails
				selectedVariant={selectedVariant}
				isModalOpen={isModalOpen}
				handleOk={handleOk}
				deviceSelecte={deviceSelecte}
				handleCancel={handleCancel}
				token={token}
			/>

			<div className="pro-container">
				<div className="innerdiv">
					<div className="vertical-images">
						{images.map((image, index) => (
							<Image
								key={index}
								src={image}
								alt={`Thumbnail ${index + 1}`}
								preview={false}
								onClick={() => setSelectedImageIndex(index)}
								style={{
									border: selectedImageIndex === index ? '2px solid #33D7DB' : '1px solid #ccc',
								}}
							/>
						))}
					</div>

					<div className="left-div">
						<Carousel
							style={{ width: '100%' }}
							arrows
							afterChange={(currentIndex) => setSelectedImageIndex(currentIndex)}
							ref={(carouselRef) => {
								if (carouselRef && carouselRef.goTo) {
									carouselRef.goTo(selectedImageIndex);
								}
							}}
							dots={false}
							speed={0}
							fade
							infinite
						>
							{images.map((image, index) => (
								<Image
									key={index}
									alt={`Slide ${index + 1}`}
									src={image}
									className="product-image"
									// preview={false}
								/>
							))}
						</Carousel>
						<div className="actions">
							<Button onClick={() => setModalOpen(true)} size="large" type="primary" block>
								Select Device
							</Button>
							{/* <Button size="large" block>
								Add to Cart
							</Button> */}
						</div>
					</div>

					<div className="right-div">
						<div className="product-variants">
							<div className="heading">Variants</div>
							{points.map((el) => {
								return (
									<>
										<div className="label">{el.label}</div>
										<div className="variant-options">
											<Radio.Group
												size="large"
												block
												options={el.options}
												defaultValue={el.options[0].value}
												optionType="button"
												onChange={(e) => {
													onOptionChange(el.key, e.target.value);
												}}
											/>
										</div>
									</>
								);
							})}
						</div>
						<div className="product-details">
							<h1>{productDeatils.productName}</h1>
							<div className="pricing">
								<span>₹{originalPrice}</span>₹{price}
							</div>
							<div style={{ marginTop: '0px' }} className="description">
								Type: {productDeatils.productType}
							</div>
							{/* <Rate style={{ marginBottom: '20px' }} disabled defaultValue={5} />{' '}
							<span>(14 reviews)</span> */}
							{productDeatils.details === '' ? null : (
								<>
									<div className="desc-heading">DETAILS</div>
									<p className="description">{productDeatils.details}</p>
								</>
							)}
							{productDeatils.features === '' ? null : (
								<>
									<div className="desc-heading">FEATURES</div>
									<p className="description">{productDeatils.features}</p>
								</>
							)}
							{productDeatils.additionFeatures === '' ? null : (
								<>
									<div className="desc-heading">ADDITIONAL FEATURES</div>
									<p className="description">
										<ShowAdditionalFeatures additionFeatures={productDeatils.additionFeatures} />
									</p>
								</>
							)}

							<div className="desc-heading">Delivery Details</div>
							<ul>
								<li>Metro cities - 4 to 5 days</li>
								<li>Tier I / Tier II - 6 to 7 days</li>
								<li>Tier III - 7-9 days.</li>
							</ul>

							{/* <ul className="description">
                                <li>Intel® Core™ i5-11th gen Processor</li>
                                <li>16GB RAM</li>
                                <li>512GB NVMe SSD Hard disk</li>
                                <li>6-8 hours hours, Longer battery life</li>
                                <li>14"-inch Display</li>
                                <li>HD FaceTime HD camera</li>
                                <li>18 months Dell warranty</li>
                                <li>Available at Store. Vijayanagar, Bengaluru.</li>
                            </ul> */}
							{/* <div className="desc-heading">RETURN & REFUND</div>
							<ul className="description">
								<li>
									New Products must be returned to us within seven (07) working days from the date on
									which you have received the product / must be dispatched to us within seven (07)
									working days from the date of receipt of the product.
								</li>

								<li>
									{' '}
									Open Box & Pre Owned Products shall be returned to us within Seven (7) working days
									from the date on which you have received the product and will be accepted only in
									case of the following :
								</li>
								<ul className="description">
									<li>Stocks are dead on arrival or have a major technical problem.</li>

									<li>The product received is physically damaged.</li>

									<li>
										Product is termed as irreparable by the service center within 30 days of
										purchase
									</li>
								</ul>
							</ul>
							<div className="desc-heading">SHIPPING INFO</div>
							<ul className="description">
								<li> Currently shipping across Bengaluru. Free delivery</li>
								<li>Cash on Delivery Available</li>
							</ul> */}
						</div>
					</div>
				</div>
			</div>
			<div onClick={() => setModalOpen(true)} className="actions2-select-button">
				<div>Select Device</div>
				{/* <Button size="large" block>
								Add to Cart
							</Button> */}
			</div>
		</>
	);
};

const success = (redirectUrl) => {
	Modal.success({
		content: `You have successfullt submited the device request, go to ${redirectUrl}`,
		title: 'Request Success',
		onOk: () => {
			window.location.href = redirectUrl;
		},
	});
};

function ProvideDeliveryDetails({ isModalOpen, handleOk, handleCancel, token, selectedVariant, deviceSelecte }) {
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	const onSave = async (values) => {
		console.log('values', values);
		try {
			const resp = await putApi(
				{ deliveryDetails: values, deviceDetails: getDevice(deviceSelecte), selectedVariant },
				`/assetze/open-api/onboarding?token=${token}`
			);
			if (resp.type === 'success') {
				success('https://assetze.com');
			} else {
				dispatch(
					showSnack('ASSET_NOT_FOUND', {
						label: resp.error,
						timeout: 7000,
					})
				);
			}
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<Modal title="Fill Delivery Details" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
			<Form form={form} onFinish={onSave} layout="vertical" hideRequiredMark>
				<Form.Item rules={[{ required: true }]} name="name" label="Name">
					<Input placeholder={'Name'} />
				</Form.Item>
				<Form.Item rules={[{ required: true }]} name="mobile" label="Mobile Number">
					<Input placeholder={'Phone Number'} />
				</Form.Item>
				<Form.Item
					rules={[{ required: true }]}
					name="flat"
					label="Flat, House no., Building, Company, Apartment"
				>
					<Input placeholder={'Flat, House no., Building, Company, Apartment'} />
				</Form.Item>
				<Form.Item rules={[{ required: true }]} name="area" label="Area, Street, Sector, Village">
					<Input placeholder={'Area, Street, Sector, Village'} />
				</Form.Item>
				<Form.Item rules={[{ required: true }]} name="pincode" label="Picode">
					<Input placeholder={'Pincode'} />
				</Form.Item>
				<Form.Item rules={[{ required: true }]} name="landmark" label="Landmark">
					<Input placeholder={'Land mark'} />
				</Form.Item>

				<Form.Item rules={[{ type: 'calendar' }]} name="doj" label="Date Of Joining">
					<DatePicker
						format={dateFormat}
						style={{ backgroundColor: 'white', width: '100%' }}
						placeholder="Date of Joining"
					/>
				</Form.Item>

				<Form.Item label={null}>
					<Button type="primary" htmlType="submit">
						Submit Request
					</Button>
				</Form.Item>
			</Form>
		</Modal>
	);
}

export default EachInventoryProduct;
